import { Component } from "@angular/core";
import { EdpUser } from "@edp-models/user.model";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "confirmation-error",
    templateUrl: "./confirmation-error.component.html",
    styleUrls: ["./confirmation-error.component.scss"],
})
export class ConfirmationErrorComponent {
    public user: EdpUser;

    constructor(private modalService: NewModalService, private readonly translateService: TranslateService) {}

    public goBack() {
        if (this.user) {
            this.goToRequestAndOperations();
        } else {
            this.goToExternalUrl();
        }
    }

    public goToRequestAndOperations() {
        this.modalService.closeModal();
    }

    public goToExternalUrl() {
        const url = this.translateService.instant("pt.edp.edponline.payment.agreement.url.edp");
        window.location.href = url;
    }
}
